<template>
  <div class="carousel-prev-next-controls">
    <ButtonIcon
      icon="back"
      size="large"
      theme="black"
      :disabled="reach == 'start'"
      @click="emits('prev')"
      aria-label="Previous"
    />
    <ButtonIcon
      icon="forward"
      size="large"
      theme="black"
      :disabled="reach == 'end'"
      @click="emits('next')"
      aria-label="Next"
    />
  </div>
</template>

<script setup lang="ts">
const props = defineProps({
  length: {
    type: Number,
    required: true,
  },
  idx: {
    type: Number,
    required: true,
  },
  reach: {},
})

const emits = defineEmits(["prev", "next"])

const { $gsap, $ScrollTrigger } = useNuxtApp()

const { app, browser, debug, storyblok } = useStores()

const refRoot = ref(null)
</script>

<style lang="scss" scoped>
@import "@/styles/shared.scss";

.carousel-prev-next-controls {
  position: relative;
  @include flex(row);
  gap: $p3;
}

button {
  pointer-events: all;
  z-index: 2000;
}

@include mobile {
  .carousel-prev-next-controls {
    gap: $p1;
  }
}
</style>
